<template>
  <div>
    <div class="message" :class="{success: message.success, fail: !message.success}">{{message.msg}}</div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.message {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
  font-size: 1em;
  padding: 0.5em;
}
.success {
  color: #2c557d;
}
.fail {
  color: darkmagenta;
}
</style>